import api from '../../../services/api';
import { DASHBOARD_PREFERENCES_VERSION } from './constants';
import { DEFAULT_DASHBOARD_PREFERENCES, type DashboardPreferences } from './types';

interface DashboardPreferencesApiResponse {
  hiddenCards?: unknown;
  version?: unknown;
  updatedAt?: unknown;
  updated_at?: unknown;
  dashboard_preferences?: unknown;
}

const normalize = (payload: DashboardPreferencesApiResponse | null | undefined): DashboardPreferences => {
  if (!payload) return DEFAULT_DASHBOARD_PREFERENCES;

  const source =
    payload.dashboard_preferences && typeof payload.dashboard_preferences === 'object'
      ? (payload.dashboard_preferences as DashboardPreferencesApiResponse)
      : payload;

  const hiddenCards = Array.isArray(source.hiddenCards)
    ? source.hiddenCards.filter((item): item is string => typeof item === 'string')
    : [];

  return {
    hiddenCards: Array.from(new Set(hiddenCards)),
    version: typeof source.version === 'number' ? source.version : DASHBOARD_PREFERENCES_VERSION,
    updatedAt:
      typeof source.updatedAt === 'string'
        ? source.updatedAt
        : typeof source.updated_at === 'string'
          ? source.updated_at
          : undefined,
  };
};

export const dashboardPreferencesService = {
  async get(): Promise<DashboardPreferences> {
    const response = await api.get<DashboardPreferencesApiResponse>('/users/me/dashboard-preferences');
    return normalize(response.data);
  },

  async update(preferences: DashboardPreferences): Promise<DashboardPreferences> {
    const payload = {
      hiddenCards: Array.from(new Set(preferences.hiddenCards)),
      version: preferences.version || DASHBOARD_PREFERENCES_VERSION,
    };
    const response = await api.put<DashboardPreferencesApiResponse>('/users/me/dashboard-preferences', payload);
    if (!response.data || (typeof response.data === 'object' && Object.keys(response.data).length === 0)) {
      return {
        ...payload,
        updatedAt: new Date().toISOString(),
      };
    }
    return normalize(response.data);
  },
};
